export enum InteractifyQueryKeys {
    ShortInit = 'interactify-short-init',
    ShortsList = 'interactify-shorts-list',
    SingleShort = 'interactify-single-short',
    Categories = 'interactify-categories',
    Labels = 'interactify-labels',
}

export type InteractionType = 'back' | 'comment-open' | 'comment-close' | `product-${number}`

export interface InteractifyPlayerRef {
    play: () => Promise<void>
    pause: () => void
    unmute: () => void
    mute: () => void
    isMuted: () => boolean
}
